import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { anchorPageMeta, anchorSchema } from 'components/common/schema'
import Template from 'components/cases/anchor'

const Anchor: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...anchorPageMeta} />
      <JsonLd data={anchorSchema} />
      <Template />
    </>
  )
}

export default Anchor
